import find from 'lodash/find'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import LicensePanel from '@freckle/school/ts/manage-teachers/components/license-header/license-panel'
import type {LicenseAttrs} from '@freckle/school/ts/manage-teachers/models/license'
import {LicenseSubjects} from '@freckle/school/ts/manage-teachers/models/license'
import {wrapper, licensesNotice, licensePanels} from './license-header.module.scss'

type Props = {
  licenses: Array<LicenseAttrs>
  currentSchool: SchoolAttrs
}

export default function LicenseHeader(props: Props) {
  const {licenses, currentSchool} = props

  const licenseNodes = LicenseSubjects.all().map(subject => {
    const license = find(licenses, license => license.subject === subject)
    return <LicensePanel key={subject} subject={subject} license={license} school={currentSchool} />
  })

  return (
    <div className={wrapper}>
      <div className={licensesNotice}>
        <SafeTrans
          i18nKey="MANAGE_TEACHERS_LICENSE_HEADER_NOTICE"
          components={{infoIcon: <i className="fa fa-info-circle" />}}
        />
      </div>
      <div className={licensePanels}>{licenseNodes}</div>
    </div>
  )
}
